<body style="background-color: #f3f3f3;">
 <!-- <app-nav-menu></app-nav-menu>-->
  <div class="container-fluid">
    <router-outlet></router-outlet>
  </div>
</body>
